import { createSignal, onCleanup, Show } from "solid-js";

const [message, setMessage] = createSignal<string>();
let timer: ReturnType<typeof setTimeout> | undefined;

/** Rows and links whose screen does not exist yet: a short "Bientôt disponible" toast. */
export function comingSoon(text = "Bientôt disponible") {
  setMessage(text);
  clearTimeout(timer);
  timer = setTimeout(() => setMessage(undefined), 2000);
}

/** Mount once per screen that calls `comingSoon`. */
export function ComingSoonToast() {
  onCleanup(() => {
    clearTimeout(timer);
    setMessage(undefined);
  });
  return (
    <Show when={message()}>
      {(m) => (
        <div
          class="pointer-events-none fixed inset-x-0 z-50 flex justify-center px-4"
          style={{ top: "calc(env(safe-area-inset-top) + 72px)" }}
          role="status"
        >
          <span class="rounded-full bg-strong px-4 py-2 text-sm leading-[1.25] tracking-[0.14px] text-white shadow-[0_2px_6px_rgba(0,0,0,0.25)]">
            {m()}
          </span>
        </div>
      )}
    </Show>
  );
}
